export default "__VITE_PUBLIC_ASSET__11cdb9b5__"